import _ from 'underscore';

export default function getRelationKey(field, row) {
	if (field.config && field.config.inverted_relation_name && _.isArray(row[field.config.inverted_relation_name])) {
		return field.config.inverted_relation_name;
	}

	return field.slug;
}
